// extracted by mini-css-extract-plugin
export var addressFields = "_ms-0";
export var animationContainer = "_ms-1";
export var footer = "_ms-2";
export var lineItems = "_ms-3";
export var modalContent = "_ms-4";
export var orderName = "_ms-5";
export var strong = "_ms-6";
export var warning = "_ms-7";